import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Loading } from '../../../common/loading'
import { Notification } from '../../../common/notification'
import { Panel } from '../../../common/panel'
import { UseScoreRange } from '../common/hooks/useScoreRange'
import { GroupNote } from '../common/html/GroupNote'
import { VALUE_SCORE } from '../constant'
import { selectScoreActive } from '../store/slice'
import { Chart } from './Chart'
import { TableItem } from './TableItem'
import classes from './index.module.scss'
import { ScoreRangeJpg } from './schema/ScoreRangeJpg'
import { getDataTable, getDataTablePer, getLoading } from './store/slice'
import {
  exportDistributionCreditRisk,
  exportDistributionPerformance,
  getDistributionCreditRisk,
  getDistributionPerformance,
} from './store/thunk'

export const TEXT_BY_TYPE_SCORE = {
  [VALUE_SCORE.CREDIT_SCORE]: {
    title: 'portfolioScore.portfolioDistributionByCredit',
    textNote: 'portfolioScore.textNotePortfolioDistributionByCredit',
    tableName: 'portfolio.summary.CREDIT_RISK_LEVEL',
  },
  [VALUE_SCORE.PERFORMANCE]: {
    title: 'portfolioScore.portfolioDistributionByGrowth',
    textNote: 'portfolioScore.textNotePortfolioDistributionByGrowth',
    tableName: 'portfolio.summary.PERFORMANCE_SCORE_LEVEL',
  },
}

export const PortfolioDistribution = () => {
  const dispatch = useDispatch()

  const settingParams = useSettingParams()
  const { value: typeValue } = useSelector(selectScoreActive)
  const { loading } = UseScoreRange()
  const dataTable = useSelector(getDataTable)
  const dataTablePer = useSelector(getDataTablePer)
  const loadingTable = useSelector(getLoading)

  const disableDownload =
    typeValue === VALUE_SCORE.CREDIT_SCORE
      ? !dataTable.length
      : !dataTablePer.length

  const downloadFunc = () => {
    if (typeValue === VALUE_SCORE.CREDIT_SCORE) {
      return exportDistributionCreditRisk(settingParams)
    }
    return exportDistributionPerformance(settingParams)
  }

  useEffect(() => {
    if (settingParams) {
      if (typeValue === VALUE_SCORE.CREDIT_SCORE) {
        dispatch(
          getDistributionCreditRisk({
            ...settingParams,
          }),
        )
      }
      if (typeValue === VALUE_SCORE.PERFORMANCE) {
        dispatch(
          getDistributionPerformance({
            ...settingParams,
          }),
        )
      }
    }
  }, [typeValue, settingParams])

  return (
    <Panel
      label={TEXT_BY_TYPE_SCORE[typeValue].title}
      isI18n
      downloadCsv={{
        downloadFunc,
        disabled: disableDownload,
      }}
      downloadJpgParams={{
        arrName: [UseI18n(TEXT_BY_TYPE_SCORE[typeValue].title)],
        disabled: disableDownload,
        titleJpg: UseI18n(TEXT_BY_TYPE_SCORE[typeValue].title),
        DownloadComponent: (
          <div>
            <GroupNote title={TEXT_BY_TYPE_SCORE[typeValue].textNote} />
            <div className="dFlex gap3 " style={{ width: 1000 }}>
              <div className="flex1">
                <Chart />
              </div>
              <div className="pt1">
                <ScoreRangeJpg typeValue={typeValue} />
              </div>
            </div>
          </div>
        ),
      }}
      style={{ paddingBottom: 4 }}
    >
      {loading || loadingTable ? (
        <div className="positionRelative" style={{ height: 200 }}>
          <Loading />
        </div>
      ) : disableDownload ? (
        <div style={{ height: 200 }}>
          <Notification />
        </div>
      ) : (
        <div>
          <GroupNote title={TEXT_BY_TYPE_SCORE[typeValue].textNote} />
          <div className={`dFlex ${classes.content}`}>
            <div className="w50 wh100">
              <Chart />
            </div>
            <div className="w50 wh100 pt1">
              <TableItem />
            </div>
          </div>
        </div>
      )}
    </Panel>
  )
}
